<!-- <h2 mat-dialog-title>{{ data.title }}</h2>
<mat-dialog-content>
  <p>{{ data.message }} hihi</p>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-button (click)="closeDialog(false)">Đóng</button>
  <button mat-raised-button color="primary" (click)="closeDialog(true)">Xác nhận</button>
</mat-dialog-actions> -->

<div class="baoTieude-customalert">
  <h2 mat-dialog-title class="Title__custompopup-alert">{{ data.title }}</h2>
  <span class="span__iconCustom-alert" (click)="closeDialog(false)">
    <i class="ti ti-x"></i>
  </span>
</div>

<mat-dialog-content class="p__customTxtCenter">
  <p class="text__customNoticePopup">{{ data.message }}</p>
</mat-dialog-content>
<mat-dialog-actions align="center">
  <button mat-button (click)="closeDialog(false)" class="Btn__custom-cancel"><i class="ti ti-xbox-x-filled icon__customAlert"></i> {{'TOAST.CLOSE'|translate}}</button>
</mat-dialog-actions>